import { Outlet } from 'react-router';

import { EulaGate } from '@/legal';

/**
 * Fullscreen layout that takes all available viewport space.
 * Used for immersive experiences like the medical image viewer.
 *
 * Its own mount of the EULA overlay is deliberate: the viewer does not render
 * inside RootLayout, and opening a case must be gated exactly as the case list
 * is. See `GATING_CHAIN` in `router/index.tsx`.
 */
export function FullscreenLayout() {
    return (
        <div className="h-screen w-screen overflow-hidden">
            <EulaGate />
            <Outlet />
        </div>
    );
}
